<template>
	<v-dialog v-model="showDialog" max-width="1200" :fullscreen="$vuetify.breakpoint.mdAndDown">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 内容確認</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<v-row no-gutters>
					<v-col sm="6" cols="12" class="pr-sm-1">
						<v-sheet elevation="0">
							<table width="100%" class="show-dialog-table">
								<tbody>
									<ShowDetailRecord
										:columnName="'シート番号'"
										:value="checkSheetTemplate.template_number"
									/>
									<ShowDetailRecord :columnName="'シート名'" :value="checkSheetTemplate.name" />
									<ShowDetailRecord
										:columnName="'最終更新者'"
										:value="checkSheetTemplate.user.full_name"
									/>
								</tbody>
							</table>
						</v-sheet>
					</v-col>
				</v-row>
				<v-sheet elevation="0" class="mt-4 table-container">
					<v-form ref="form" v-model="valid">
						<table width="100%" class="show-dialog-table">
							<tbody>
								<th class="font-weight-bold" :style="width(100)">QC番号</th>
								<th class="font-weight-bold" :style="width(150)">作業工程</th>
								<th class="font-weight-bold" :style="width(200)">チェック項目</th>
								<th class="font-weight-bold" :style="width(200)">チェック方法</th>
								<th class="font-weight-bold" :style="width(200)">チェック基準</th>
								<th class="font-weight-bold" :style="width(200)">保存結果のデータ形式</th>
								<th class="font-weight-bold" :style="width(80)">確認</th>
							</tbody>
							<tbody>
								<tr v-for="item in checkSheetTemplate.check_items" :key="item.id">
									<td>
										{{ item.qc_number }}
									</td>
									<td>
										{{ item.small_process_type.name }}
									</td>
									<td>
										{{ item.name }}
									</td>
									<td>
										{{ item.check_method }}
									</td>
									<td>
										{{ item.standard }}
									</td>
									<td>
										{{ item.data_type }}
									</td>
									<td>
										<v-checkbox />
									</td>
								</tr>
							</tbody>
						</table>
					</v-form>
				</v-sheet>
			</div>
			<v-row no-gutters class="py-4" justify="end">
				<v-btn @click="accept()" color="black" :disabled="!isAllChecked" text>{{
					actionName
				}}</v-btn>
				<v-btn @click="closeDialog()" text>キャンセル</v-btn>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		checkSheetTemplate: {
			type: Object,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			valid: false,
			common,
			rules,
		}
	},
	methods: {
		accept() {
			// TODO: 確認・承認
			const headers = authenticate.setHeader()
			const url = `/erp/v1`
			axios
				.post(url, {
					headers,
				})
				.then((res) => {
					this.$emit("accept")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.showDialog = false
		},
		width(number) {
			return { "min-width": `${number}px`, "max-width": `${number}px` }
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
		actionName() {
			if (this.checkSheetTemplate.status == "approval_pending") {
				return "承認"
			} else if (this.checkSheetTemplate.status == "confirmation_pending") {
				return "確認"
			} else {
				return ""
			}
		},
		isAllChecked() {
			// TODO:
		},
	},
	watch: {
		checkSheetTemplate: {
			handler(val) {
				this.checkSheetTemplate = val
			},
			deep: true,
		},
	},
}
</script>
